import {Trans} from '@lingui/macro';
import {noop} from 'lodash';
import React, {FC} from 'react';

import {TabButtonElement} from '../../analytics/components/tabs/tabButtonElement';
import {useLinkNavigation} from '../../components/common/navigation/useLinkNavigation';
import {CustomFieldResourceTypesEnum} from '../../models/api/customFieldModel';
import {buildSettingsPath} from '../../models/url/settingsUrlHelpers';
import {SettingsResourcePagesEnum, SettingsTeammateUrl} from '../../models/url/settingsUrlModel';
import {StyledSettingsWrapper} from '../common/settingsWrapper';
import {SettingsCustomFieldAttributeImportCsvContainer} from '../customFieldAttributes/settingsCustomFieldAttributeImportCsvContainer';
import {SettingsHeader} from '../settingsHeader';

export const SettingsTeammatesImportCustomAttributes: FC<{url: SettingsTeammateUrl}> = ({url}) => {
  const {navigateToLink} = useLinkNavigation();

  const tabs = [
    <TabButtonElement
      key="list"
      name={<Trans id="settings-teammates-tab-list">All teammates</Trans>}
      isSelected={false}
      onTabClick={() =>
        navigateToLink(
          buildSettingsPath({
            ...url,
            resourcePage: SettingsResourcePagesEnum.OVERVIEW,
          }),
        )
      }
    />,
    <TabButtonElement
      key="import-custom-attributes"
      name={<Trans id="settings-teammates-tab-import-custom-attributes">Bulk edit custom fields</Trans>}
      isSelected
      onTabClick={noop}
    />,
  ];

  return (
    <StyledSettingsWrapper>
      <SettingsHeader tabs={tabs}>
        <Trans id="settings-teammates-header">Teammates</Trans>
      </SettingsHeader>
      <SettingsCustomFieldAttributeImportCsvContainer
        resourceType={CustomFieldResourceTypesEnum.TEAMMATE}
        namespace={url.namespace}
      />
    </StyledSettingsWrapper>
  );
};
